/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import appInfo from '../app.info.json';
import apiConst from './api.constant';

export default {
  ...apiConst,
  application: {
    name: 'WeatherSpork',
    version: appInfo.version,
    bundleVersion: appInfo.bundleVersion,
  },
  apiCaches: {
    gribCache: 'gribCache',
  },
  walthroughAction: {
    previous: 1,
    next: 2,
    finish: 3,
  },
  iphoneSafeArea: {
    top: 20,
    bottom: 36,
  },
  allowedAirportTabs: ['meteogram',
    'radar',
    'metars',
    'tafs',
    'skew-t',
    'fcstdiscussion'],
  observationActionKeys: [
    'metars',
    'radar',
    'skew-t',
  ],
  forecastActionKeys: [
    'meteogram',
    'tafs',
    'fcstdiscussion',
  ],
  mountDelay: 1000,
  throttleModalClick: 2000,
  splitPaneWhen: 'xl',
  mobileGridColumnMin: 10,
  webGridColumnMin: 22,
  minimumAirportsSlidesRequired: 11,
  httpRequestTimeoutsJSONBLOB: 30000,
  httpRequestTimeouts: 30000,
  httpRequestTimeoutsGrib: 20000,
  eulaSecondaryTimeout: 3000,
  eulaVersion: 20240815,
  defaultHomeViewState: 'app.dashboard',
  defaultShowBarbHead: true,
  elevationSamples: 400,
  fixedCycleTime: 5000,
  timeoutFloatingEtd: 500,
  imageryDefaultBackText: 'Imagery',
  imageryDefaultDelay: 1000,
  imagerySliderHeight: 68,
  lengthToShowTooltip: 18,
  surface: 'SFC',
  flightLevel: 'FL',
  flightLevelAltitude: 18000,
  defaultLeftSideAnchor: 30,
  mapViewPlaneText: 'Time: ',
  usernameKeyCognito: 'LastAuthUser',
  noUser: 'NOUSER',
  buserPreferredDatedFormat: 'd MMM yyyy',
  processingText: 'Processing...',
  loginFailedMessage: 'Invalid email address or password.',
  magicLinkLimitExceed: 'For security purposes, you can only request a magic link once every 60 seconds.',
  contactSupport: 'ContactSupport',
  userAlreadyRegistered: 'UserAlreadyRegistered',
  passwordConstraintNotMet: 'Password not valid. Please try different password',
  googleMapsDevApiKey: 'AIzaSyAMcH5r8C-JgHaKNMBgGXnBTysui7WCqFw',
  googleMapsProdApiKey: 'AIzaSyBQZ-qy1Am-VY8u4GxZPiXgibIMv-3UJ00',
  elevetionApiKey: 'AIzaSyC8cSINqESn7VH1Ieep7pb68vis1Soqn8Q',
  imageryNoLongerValid: 'NOT_VALID_IMAGERY',
  imageryPlaceholderText: 'Please select imagery to view.',
  imageryLoadFailedPlaceholderText: 'Failed to load imagery.',
  imageryLoadFailed404PlaceholderText: 'Image not available.',
  gaIdMobile: 'UA-96764426-1',
  gaIdWeb: 'UA-96764426-2',
  defaultSortBy: 'titleatoz',
  defaultMapStyle: 'GeoJson',
  keyTrialExpiredIap: 'Trialexpire:IAP:',
  mapLayerTypes: ['OpenStreetMap.BlackAndWhite', 'Stamen.Terrain', 'GeoJson', 'ESRI.WorldTopoMap'],
  oneTimeUpdateKey: 20220420,
  DataSourceAloft: 'data/aloft.json',
  debounceMillisecondSlider: 700,
  debounceMapZoom: 400,
  debounceStore: 1000,
  gribRequestLag: 50,
  defaultIgnoreMidpoints: false,
  defaultSliderPinned: true,
  defaultSynch7DayAirport: true,
  defaultHeadOnlyWind: true,
  defaultEnableCeilingSeries: false,
  defaultGroundSpeed: 130,
  minGroundSpeed: 50,
  maxGroundSpeed: 999,
  hoursSleepToForceReload: 0.25,
  stormExpiryThresholdMinutes: -15,
  defaultWeatherApi: 'mapClick',
  workshopNotAvailable: {
    okType: 'button-dark',
    title: 'Workshop not available',
    template: 'Please contact support@weatherspork.com for assistance.',
  },
  possibleWeatherApi: {
    govWeather: 'govWeather',
    mapClick: 'mapClick',
  },
  aviationFallbacks: ['/api/awg/'],
  httpCacheAge: 300000,
  mrmsDataAge: 300000,
  metarRequestAge: 1800000,
  mosRequestAge: 900000,
  stormTrackRequestAge: 120000,
  idleTimeout: 1000,
  cloudCacheEnabled: true,
  gribCacheAge: 28800000, // 8Hours
  applicationBaseDirectory: '',
  aviationGairmetsIntervals: [0, 3, 6, 9, 12],
  metServiceProvider: 'aviationmet',
  possibleMetServiceProvider: {
    bnforecast: 'bnforecast',
    bnforecastAllMets: 'bnforecastAllMets',
    aviationmet: 'aviationmet',
  },
  sideMenuWidth: 225,
  imageryAccordWidth: 225,
  footerHeightExtraiPhoneX: 12,
  footerHeight: null,
  headerHeight: null,
  headerHeightMobile: 76,
  headerHeightMobileiPhoneX: 100,
  sliderHeight: 75,
  sliderHeightSecondary: 70,
  secondarySliderFloatPad: 4,
  dc1: 'wxspork',
  jsonBlobLoadingMessage: 'Please wait. Getting JSON data for the view',
  exSubFor9999Rec: 'Found airport [AIRPORT] with 9999 aloft records',
  requestProduct: 'LAMPMAV',
  alternateColorSchemeRuleKey: 'i',
  defaultRulesetKey: 'r',
  aloftValueToTreatAsNull: 9999,
  exceptionsCodes: {
    NotAuthorizedException: 'NotAuthorizedException',
    UsernameExistsException: 'UsernameExistsException',
    UserNotFoundException: 'UserNotFoundException',
    InvalidParameterException: 'InvalidParameterException',
    incorrectPassword: 'Incorrect username or password',
    networkFailure: 'Network Failure',
    networkError: 'NetworkError',
    ExpiredCodeException: 'ExpiredCodeException',
  },
  expiredCodeExceptionMessage: 'Invalid code entered, please try again.',
  requestProductAll: 'ALL',
  messageToClearLS: 'Are you sure you want to clear localStorage?',
  dataMode: {
    meteogram: 'meteogram',
    routeprofile: 'routeprofile',
    mapview: 'mapview',
    gridview: 'gridview',
    leafletmapview: 'leafletmapview',
    weekly: 'weekly',
    avwx: 'avwx',
    workshop: 'workshop',
  },
  timeZones: {
    local: {
      key: 'L',
    },
    zulu: {
      key: 'Z',
    },
  },
  extendedCeiling: {
    min: 100,
    max: 20000,
  },
  temperatureUnits: {
    fahrenheit: {
      key: 'F',
      baseValue: 32,
      minValue: -40,
      maxValue: 120,
    },
    celsius: {
      key: 'C',
      baseValue: 0,
      minValue: -40,
      maxValue: 48.8889,
    },
  },
  errorReporting: {
    mailto: 'support@weatherspork.com',
    subject: 'WeatherSpork: Error occured',
  },
  jsonBlobReporting: {
    subject: 'WeatherSpork: JSON snapshot',
  },
  stateMap: {
    dashboard: {
      key: 'app.dashboard',
      icon: 'trendingUp',
      fontawesome: false,
    },
    routeprofile: {
      key: 'app.routeprofile',
      icon: 'route',
      fontawesome: true,
    },
    gridview: {
      key: 'app.gridview',
      icon: 'hashtag',
      fontawesome: true,
    },
    leafletmapview: {
      key: 'app.leafletmapview',
      icon: 'globe',
      fontawesome: false,
    },
    mapview: {
      key: 'app.mapview',
      icon: 'globe',
      fontawesome: false,
    },
    weather: {
      key: 'app.weather',
      icon: 'trendingUp',
      fontawesome: false,
    },
    workshops: {
      key: 'app.workshops',
      icon: 'videocam',
      fontawesome: false,
    },
    developer: {
      key: 'app.developer',
      icon: 'bug',
      fontawesome: false,
    },
    avwxtab: {
      key: 'app.avwxtab',
      icon: 'images',
      fontawesome: false,
    },
    imagery: {
      key: 'app.imagery',
      icon: 'images',
      fontawesome: false,
    },
  },
  dc2: '69420!',
  sH: '786E8343C39158C9F15A55E59E5B3',
  localstorageConf: {
    prefix: 'bn_',
    lastViewedStateKey: 'lastViewedStateKey',
    applicationSettingKey: 'applicationSetting',
    deviceSpecificSettingKey: 'deviceSpecificSetting',
    routeprofileSettingKey: 'routeprofileSetting',
    globeviewSettingKey: 'globeviewSettingKey',
    mapviewSettingKey: 'mapviewSetting',
    meteogramSettingKey: 'meteogramSetting',
    weatherSettingKey: 'weatherSetting',
    workshopSettingKey: 'workshopSetting',
    imagerySettingKey: 'imagerySetting',
    airportKey: 'airportsHistory',
    serviceHost: 'serviceHost',
    supaApiUrl: 'supaApiUrl',
    supaApiKey: 'supaApiKey',
    fullDataKey: 'fullData',
    avwxUser: 'avwxUser',
    avwxUserOld: 'avwxUserOld',
    favoriteList: 'favoriteMarkedViews',
    suppressedMets: 'suppressedMets',
    applicationVersion: 'applicationVersion',
    lastOtuOn: 'lastOtuOn',
    tu: 'tu', // trial date start ///this will also be used as appInstallDate
    preBootstrapLastOtuOn: 'preBootstrapLastOtuOn',
    unregisteredUser: 'unregisteredUser',
    forgotPwdState: 'forgotPwdState',
    gribCacheKey: 'angular-cache.caches.gribCache',
    lastVersionCheckedForUpdate: 'lastVersionCheckedForUpdate',
    lastMessageOfDaySeen: 'lastMessageOfDaySeen',
    sevenDayWeatherApiUrlsMapping: 'sevenDayWeatherApiUrlsMapping',
    lastEdt: 'lastEdt',
    paypalPlans: 'paypalPlans',
    firstSoftAskGeolocationAccess: 'firstSoftAskGeolocationAccess',
    geoLocationPermissionGiven: 'geoLocationPermissionGiven',
    subscriptionExpireSoonReminder: 'subscriptionExpireSoonReminder',
    uc: 'uc',
    uc_copy: 'uc_copy', // this is used for relogin if user gets logged out due to expiry of token
  },
  tourOverlayDelayTimeout: 150,
};
